import { SelectInput, TextInput } from "react-admin";
import {
  getAsharaVenueChoices,
  getJamanVenueChoices,
  getNamaazVenueChoices,
} from "@/utils/event-venue-utils";
import type { CurrentEvent } from "@/containers/events/types";

const filterFieldSx = { minWidth: { xs: "100%", sm: 200 }, maxWidth: { sm: 360 } } as const;

const YES_NO_CHOICES = [
  { id: "true", name: "Yes" },
  { id: "false", name: "No" },
] as const;

/** API query booleans accept true/false strings from flattened react-admin filters. */
const parseOptionalBoolean = (value: unknown): boolean | undefined => {
  if (value === "" || value == null) return undefined;
  if (value === true || value === "true") return true;
  if (value === false || value === "false") return false;
  return undefined;
};

const parseOptionalGtZero = (value: unknown): number | undefined => {
  if (value === "" || value == null) return undefined;
  return 0;
};

export const buildNiyaazListFilters = (
  isAshara: boolean,
  currentEvent: CurrentEvent | null | undefined
) => {
  const venueFilters = isAshara
    ? [
        <SelectInput
          label="Venue"
          source="markaz"
          key="markaz"
          choices={getAsharaVenueChoices(currentEvent)}
          alwaysOn
          emptyText="All venues"
          sx={filterFieldSx}
        />,
      ]
    : [
        <SelectInput
          label="Jaman Venue"
          source="markaz"
          key="markaz"
          choices={getJamanVenueChoices(currentEvent)}
          alwaysOn
          emptyText="All jaman venues"
          sx={filterFieldSx}
        />,
        <SelectInput
          label="Namaaz Venue"
          source="namaazVenue"
          key="namaazVenue"
          choices={getNamaazVenueChoices(currentEvent)}
          alwaysOn
          emptyText="All namaaz venues"
          sx={filterFieldSx}
        />,
      ];

  return [
    <TextInput
      label="Search name, ITS, form no, phone"
      source="search"
      alwaysOn
      key="search"
      sx={{ minWidth: { xs: "100%", sm: 280 }, maxWidth: { sm: 420 } }}
    />,
    ...venueFilters,
    <SelectInput
      label="Payment status"
      source="paymentStatus"
      key="paymentStatus"
      alwaysOn
      choices={[
        { id: "outstanding", name: "Outstanding balance" },
        { id: "paid", name: "Fully paid" },
      ]}
      emptyText="All"
      sx={filterFieldSx}
    />,
    <SelectInput
      label="Send reminders"
      source="sendReminders"
      key="sendReminders"
      choices={[...YES_NO_CHOICES]}
      emptyText="All"
      parse={parseOptionalBoolean}
      sx={filterFieldSx}
    />,
    <SelectInput
      label="Zabihat"
      source="zabihat_gt"
      key="zabihat_gt"
      choices={[{ id: 0, name: "Has zabihat" }]}
      emptyText="All"
      parse={parseOptionalGtZero}
      sx={filterFieldSx}
    />,
    <SelectInput
      label="Pirsa"
      source="pirsa_gt"
      key="pirsa_gt"
      choices={[{ id: 0, name: "Has pirsa" }]}
      emptyText="All"
      parse={parseOptionalGtZero}
      sx={filterFieldSx}
    />,
    ...(isAshara
      ? [
          <SelectInput
            label="Relay"
            source="relayRequired"
            key="relayRequired"
            choices={[...YES_NO_CHOICES]}
            emptyText="All"
            parse={parseOptionalBoolean}
            sx={filterFieldSx}
          />,
        ]
      : []),
  ];
};
